import { track } from '@tldraw/tldraw'
import { ItalicProps } from './Types'
import { Italic as Icon } from 'blaze-ui/icons'
import { useUpdateStyle } from '../VisualEditor/hooks/useUpdateStyle'
import { ItalicStyle } from '../VisualEditor/StyleProps'
import { toggleProseMark, useActiveProseMarks } from '../Shapes/TextBoxShape/activeProseView'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { observer } from 'mobx-react-lite'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { useAvailableItalic } from '../VisualEditor/hooks/useAvailableItalic'

const Italic = track(
  observer(({ editor, fontWeightStyle, fontFamilyStyle, italicStyle, tooltipPlacement }: ItalicProps) => {
    const updateStyle = useUpdateStyle(editor)
    const proseMarks = useActiveProseMarks()
    const availableItalic = useAvailableItalic(fontFamilyStyle, fontWeightStyle)

    // Italic requires the font to have an italic face — whether we're editing the `em` mark or the
    // whole-shape italic (otherwise we'd emit an em run the lambda can't render). Outside prose editing a
    // mixed weight also disables it. Symmetric with Bold's capability guard.
    const isDisabled = !availableItalic || (!proseMarks && fontWeightStyle.type === 'mixed')
    const isToggled = proseMarks ? proseMarks.em === 'all' : italicStyle.type === 'shared' && italicStyle.value

    return (
      <Tooltip label="Italic" placement={tooltipPlacement}>
        <Button
          isDisabled={isDisabled}
          variant={isToggled ? 'squareToggleOn' : 'squareToggleOff'}
          onPress={() => {
            if (!toggleProseMark('em')) updateStyle(ItalicStyle, !isToggled)
          }}
          aria-label="Italic"
          icon={() => <Icon size={20} />}
        />
      </Tooltip>
    )
  }),
)

export { Italic }
